import React, { useState } from 'react';
import InputMask from 'react-input-mask';
import { useDispatch } from 'react-redux';

import { Form, StyledInput } from '../../Login/style';
import { CommonButton } from '../Buttons';

import { firstAcessChangePassword } from '../../../actions/Auth';
import { Grid } from '@material-ui/core';

export const FormFirstAcess = ({ setFirstAcess }) => {
  const dispatch = useDispatch();

  const [login, setLogin] = useState({
    cpf: '',
    senha: '',
  });
  const [loading, setLoading] = useState(false);

  const handleRecover = async () => {
    try {
      setLoading(true);
      await dispatch(await firstAcessChangePassword(login));
    } finally {
      setFirstAcess(false);
      setLoading(false);
    }
  };

  return (
    <Form autoComplete="off" noValidate>
      <StyledInput inputProps={{ maxLength: 11 }} label="CPF - Apenas números" variant="outlined" onChange={(e) => setLogin({ ...login, cpf: e.target.value })} />
      <StyledInput marginbottom={8} label="Senha" type="password" variant="outlined" onChange={(e) => setLogin({ ...login, senha: e.target.value })} />
      <Grid container spacing={1} style={{ margin: -2 }}>
        <Grid item xs={6}>
          <CommonButton label="Voltar" action={() => setFirstAcess(false)} />
        </Grid>
        <Grid item xs={6}>
          <CommonButton loading={loading} disabled={login.cpf && login.senha ? false : true} label="Alterar" action={() => handleRecover()} />
        </Grid>
      </Grid>
    </Form>
  );
};
